import { isEmpty } from 'lodash';

const presenceObject = { presence: { allowEmpty: false } };

export default (key, mandate = true) => ({
  [key]: {
    array: {
      ...(mandate ? presenceObject : {}),
      operands: {
        array: {
          attribute: function(
            value,
            attributes,
            attributeName,
            options,
            constraints
          ) {
            // Currently nested object validation unsupported
            if (!isEmpty(attributes?.operands)) {
              return false;
            }

            return {
              presence: {
                allowEmpty: false
              }
            };
          },

          operator: {
            equality: {
              attribute: 'operatorValue',
              message: '^This value cannot be empty',
              comparator: function(
                value,
                operator,
                options,
                attribute,
                attributes
              ) {
                if (!value && operator) {
                  return true;
                }
                if (value) {
                  return true;
                }
                return false;
              }
            }
          },
          value: {
            equality: {
              attribute: 'operator',
              message: '^This value cannot be empty',
              comparator: function(
                value,
                operator,
                options,
                attribute,
                attributes
              ) {
                const exceptedOperators = ['isEmpty', 'isNotEmpty'];
                if (attributes.operatorValue) {
                  return true;
                }
                if (!value && !(typeof value === 'boolean')) {
                  if (exceptedOperators.includes(operator)) {
                    return true;
                  }
                  return false;
                }

                // Validation for dual field operators (between)
                if (operator === 'between' && Array.isArray(value)) {
                  const startValue = value?.[0]?.name || value?.[0];
                  const endValue = value?.[1]?.name || value?.[1];

                  if (!startValue || !endValue) {
                    return false;
                  }
                }

                return true;
              }
            }
          }
        }
      }
    }
  }
});
